import layoutHeaderAside from '@/layout/header-aside'
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 公棚路由
export default [
  {
    path: '/shed',
    name: 'Shed',
    meta: {
      title: '公棚设置',
      auth: true
    },
    redirect: { name: 'ShedIndex' },
    component: layoutHeaderAside,
    children: [
      {
        path: '/shed/index',
        name: 'ShedIndex',
        meta: {
          title: '基本信息',
          auth: true
        },
        component: _import('shed/index')
      },
      {
        path: '/shed/intro',
        name: 'ShedIntro',
        meta: {
          title: '公棚简介',
          auth: true
        },
        component: _import('shed/intro')
      },
      // {
      //   path: '/shed/notice',
      //   name: 'ShedNotice',
      //   meta: {
      //     title: '滚动公告',
      //     auth: true
      //   },
      //   component: _import('shed/notice')
      // }
    ]
  }
]
